<template>
  <div class="flex flex-row items-center mb-8 font-semibold">
    <span
      :class="{
        'bg-secondary dark:bg-secondary/20 dark:text-secondary text-white py-1 px-2 rounded-full text-xs': isDark,
        'text-lg': !isDark,
      }"
      class="whitespace-nowrap"
    >
      {{ $filters.danishize(title) }}
    </span>
    <hr
      :class="{
        'border-secondary-light dark:border-zinc-700': isDark,
        'border-gray-light dark:border-zinc-700': !isDark,
      }"
      class="w-full ml-4"
    >
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: 'title'
  },
  isDark: {
    type: Boolean,
    default: false
  }
})
</script>
